"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CircleButton = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var circle_button_scss_1 = tslib_1.__importDefault(require("./circle-button.scss"));
var CircleButton = /** @class */ (function (_super) {
    tslib_1.__extends(CircleButton, _super);
    function CircleButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CircleButton.prototype.render = function () {
        var _a = this.props, children = _a.children, _b = _a.borderWidth, borderWidth = _b === void 0 ? 2 : _b;
        return (react_1.default.createElement("div", { style: {
                borderWidth: borderWidth,
            }, className: circle_button_scss_1.default.circleButton }, children));
    };
    return CircleButton;
}(react_1.default.Component));
exports.CircleButton = CircleButton;
//# sourceMappingURL=circle-button.js.map